import { createSlice } from '@reduxjs/toolkit';
import  type { MenuState } from '../data/interfaces/sharedmodels';


// Define the initial state using that type
const initialState: MenuState = {
  isMenuOpen: false,
  currentMenu:'dashboard'
}
export const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    menuopen: (state) => {
      state.isMenuOpen=true;
    },
    menuclose: (state) => {
      state.isMenuOpen=false;
    },
    setcurrentmenu:(state,action)=>{
      state.currentMenu=action.payload;
    }
  },
});

export const { menuopen,menuclose,setcurrentmenu } = menuSlice.actions

export default menuSlice.reducer